import React from "react";
import ReactDOM from "react-dom";
import { Router as BrowserRouter } from "react-router-dom";
import Keycloak from "keycloak-js";
import { Provider } from "react-redux";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ReduxToastr from "react-redux-toastr";
import { compileInterceptors } from "./api/InterceptorCombiner";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "chartjs-plugin-datalabels";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ubuntu.css";
import "./index.css";
import "./pawnshop_styles.css";
import "./chart_styles.css";
import "./App.scss";
import MomentUtils from "@date-io/moment";
import store from "./store";
import history from "./history";
import * as serviceWorker from "./serviceWorker";
import { toastr } from "react-redux-toastr";
import { keycloak_client_path } from "./constants/hosts/hosts";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "moment-timezone";
import moment from "moment";
import 'chartjs-plugin-piechart-outlabels'

const path = require("path");

export const keycloak = new Keycloak(keycloak_client_path);

moment.tz.setDefault("Asia/Shanghai");

const AppRender = () => {
  const root = (
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter basename="/pawnshop-reports" history={history}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <App />
          </MuiPickersUtilsProvider>
          <ReduxToastr
            timeOut={4000}
            newestOnTop={true}
            preventDuplicates={true}
            position="top-center"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            attention={true}
            progressBar={false}
            closeOnToastrClick={false}
          />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  );

  ReactDOM.render(root, document.getElementById("root"));
};

// converted to subscriber event so that it will not be bound on the promise-based approach on render
keycloak.onAuthSuccess = () => {
  store.dispatch({
    type: "keycloak:AppendDetails",
    payload: {
      keycloak: keycloak,
      authenticated: true,
    },
  });
  compileInterceptors(keycloak);
  AppRender();
};

///separated this as well
keycloak.onAuthError = (errorData) => {
  toastr.error(errorData);
};

/// Initialized when the keycloak was not yet authenticated
/// if its already authenticated, just render the main content
/// mechanism states that it will revalidate keycloak state when reloading
if (!keycloak.authenticated) {
  keycloak.init({
    onLoad: "login-required",
    checkLoginIframe: false,
  });
} else {
  AppRender();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
